import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { faPowerOff } from '@fortawesome/pro-regular-svg-icons';
import { ENVIRONMENT_SETTINGS } from '@reconcept-platform/env';
import { WebSessionService } from '@reconcept-platform/shared/authentication';
import { SharedViewerApi } from '@reconcept-platform/shared/data-access';
import { type NavConfig, NavigationService } from '@reconcept-platform/shared/navigation/nav-content';
import { derivedAsync } from 'ngxtension/derived-async';
import { type Observable, of } from 'rxjs';

@Component({
  selector: 'rcp-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TopNavComponent {
  private navigationService = inject(NavigationService);
  private session = inject(WebSessionService);
  private sharedViewerApi = inject(SharedViewerApi);

  readonly logoUrl = input.required<string>();

  isOnboarded = input<boolean>();
  showApplicationName = input<boolean>(true);

  environment = inject(ENVIRONMENT_SETTINGS);

  private isLoggedIn = toSignal(this.session.isLoggedIn$);

  private viewerIsOnboarded = derivedAsync(() => {
    if (this.isLoggedIn()) {
      return this.sharedViewerApi.watchViewerIsOnboarded();
    }
    return of(false);
  });

  showStandaloneLogout = computed(
    () => this.isLoggedIn() && this.navigationService.hasParentNavConfig() && !this.viewerIsOnboarded(),
  );

  canGoToDashboard = computed(
    () => this.isLoggedIn() && this.navigationService.hasParentNavConfig() && this.viewerIsOnboarded(),
  );

  showStandaloneLogout$: Observable<boolean>;

  // needs to be a getter, because config can get updated at a later moment.
  get navConfig(): NavConfig {
    return this.navigationService.getNavConfig();
  }

  goBack() {
    this.navigationService.goBack();
  }

  logout() {
    this.session.logout();
  }

  protected readonly faPowerOff = faPowerOff;
}
